import { render, staticRenderFns } from "./DataTableTollsScale.vue?vue&type=template&id=2b93977b&"
import script from "./DataTableTollsScale.vue?vue&type=script&lang=js&"
export * from "./DataTableTollsScale.vue?vue&type=script&lang=js&"
import style0 from "./DataTableTollsScale.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports